import React from "react";
import styles from "./Fourth.module.scss";
import SVG from "react-inlinesvg";
import OvalSpinner from "../../OvalSpinner";
import { TYPE_BUTTON } from "../types";

const WIDTH__DEFAULT = "16px";

const HEIGHT_DEFAULT = "16px";

export default function Fourth(fourthProps) {
  const { onClick, isLoading, type, disabled, label, icon, withShadow } =
    fourthProps;

  const ButtonClassName = `${styles.fourthButton} ${
    disabled ? styles.disabled : styles.enabled
  }`;

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type ?? TYPE_BUTTON.BUTTON}
      className={ButtonClassName}
    >
      {isLoading && (
        <div className={styles.spinnerWrapper}>
          <OvalSpinner height={HEIGHT_DEFAULT} width={WIDTH__DEFAULT} />
        </div>
      )}
      {icon && (
        <div className={styles.iconWrapper}>
          <SVG src={icon} />
        </div>
      )}
      <span className={styles.textWrapper}>{label}</span>
    </button>
  );
}
